export const getValidLink = (link: string) => {
    // If does not contain any protocol (eg. http/https), add http
    if (!link.match(/^[a-zA-Z]+:\/\//))
    {
        link = 'http://' + link;
    }
    return link;
}


// WEBPACK FOOTER //
// ./src/utils/uriParsing.ts